import type { EdgeRecord } from '../../edges/EdgeData';
import type { BoxLabels, NodeId, NodeRecord } from '../../nodes';

export interface GraphExportData {
  boxLabels: BoxLabels;
  edges: EdgeRecord;
  /**
   * If present, hidden nodes and connected edges will be rendered as semitransparent.
   * To prevent rendering nodes and edges completely, remove them from nodes/edges field.
   */
  hiddenNodes?: Set<NodeId>;
  nodes: NodeRecord;
}
